import { render, staticRenderFns } from "./VuelvePromo.vue?vue&type=template&id=ffec2b0a&scoped=true&"
import script from "./VuelvePromo.vue?vue&type=script&lang=js&"
export * from "./VuelvePromo.vue?vue&type=script&lang=js&"
import style0 from "./VuelvePromo.vue?vue&type=style&index=0&id=ffec2b0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffec2b0a",
  null
  
)

export default component.exports